export const numbersListRegex = /^[\d, ]+$/;
export const numbersRangesListRegex = /^(\d+ ?- ?\d+ ?,? ?)+$/;


export const checkRule = (regexStr, val) => {
    if (!regexStr) return false;
    try {
        return new RegExp(regexStr).test(val);
    } catch {
        return false;
    }
};